import { Ref } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdFirstPage, MdLastPage } from 'react-icons/md';
import { VscGripper } from 'react-icons/vsc';
import { Appearance, Placement, Size } from '@Components/designConstants';
import { IconButton } from '@Components/IconButton';

interface ColumnTopProps {
  noHeaders?: boolean;
  hasSuperHeader?: boolean;
  onSuperHeaderAdd?: () => void;
  handleRef: Ref<HTMLDivElement>;
  i: number;
  addColumn: (i: number) => void;
  color?: string;
}

export const ColumnTop = ({
  color,
  onSuperHeaderAdd,
  hasSuperHeader,
  handleRef,
  i,
  addColumn,
  noHeaders
}: ColumnTopProps) => (
  <>
    <div className='stripe' style={{ backgroundColor: color || 'black' }} />
    <div className='top-actions'>
      <OverlayTrigger placement={Placement.TOP_START} overlay={<Tooltip>Drag and drop</Tooltip>}>
        <div className='drag-handle' ref={handleRef}>
          <VscGripper />
        </div>
      </OverlayTrigger>
      <div className='add-actions'>
        <div className='add-label'>Add:</div>
        <OverlayTrigger
          placement={Placement.TOP_END}
          overlay={<Tooltip>Column to the left</Tooltip>}
        >
          <IconButton appearance={Appearance.OUTLINED} onClick={() => addColumn(i)} size={Size.MD}>
            <MdFirstPage />
          </IconButton>
        </OverlayTrigger>
        {!noHeaders && (
          <OverlayTrigger
            placement={Placement.TOP}
            overlay={
              <Tooltip>{hasSuperHeader ? 'There is already a header' : 'Header above'}</Tooltip>
            }
          >
            <IconButton
              size={Size.MD}
              appearance={Appearance.OUTLINED}
              className='add-header-button'
              disabled={hasSuperHeader}
              onClick={onSuperHeaderAdd}
            >
              <MdFirstPage className='add-header-icon' />
            </IconButton>
          </OverlayTrigger>
        )}
        <OverlayTrigger
          placement={Placement.TOP_START}
          overlay={<Tooltip>Column to the right</Tooltip>}
        >
          <IconButton
            appearance={Appearance.OUTLINED}
            onClick={() => addColumn(i + 1)}
            size={Size.MD}
          >
            <MdLastPage />
          </IconButton>
        </OverlayTrigger>
      </div>
    </div>
  </>
);
